module.exports = __webpack_public_path__ + "img/skin.94239b38.svg";